const tabList = (handleTabChange, tabValue) => [
  {
    label: 'Create with AI',
    onClick: () => handleTabChange(6),
    isActive: tabValue === 6,
  },
  {
    label: 'My Media',
    onClick: () => handleTabChange(1),
    isActive: tabValue === 1,
  },
  {
    label: 'Add by Link',
    onClick: () => handleTabChange(5),
    isActive: tabValue === 5,
  },
  {
    label: 'Giphy',
    onClick: () => handleTabChange(3),
    isActive: tabValue === 3,
  },
  {
    label: 'Unsplash',
    onClick: () => handleTabChange(4),
    isActive: tabValue === 4,
  },
]

export default tabList
